import { useNavigate } from 'react-router-dom';
import { useAdmin } from './useAdmin';
import { useDisconnect } from 'wagmi';

export function useLogout() {
  const navigate = useNavigate();
  const { setAdminEnabled } = useAdmin();
  const { disconnect } = useDisconnect();

  const logout = () => {
    // Clear authentication state
    localStorage.removeItem('trinity_auth');
    localStorage.removeItem('trinity_is_admin');
    
    // Reset admin state
    setAdminEnabled(false);
    
    // Disconnect wallet
    disconnect();
    
    // Navigate to a protected route which will trigger the PasswordGate
    navigate('/accounts', { replace: true });
    
    // Force a refresh after a short delay to ensure navigation completes
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return logout;
} 